/**
 * Determines if caching should be disabled based on the 'nocache' query parameter.
 * Server-side: checks the provided Request object's URL
 * Client-side: checks the current page URL (window.location.href)
 *
 * @param request - Request object (server-side only)
 * @returns true if nocache=true is present in the URL, false otherwise
 */
export function getNoCacheFromRequest(request?: Request): boolean {
  try {
    let urlString: string;

    if (request instanceof Request) {
      urlString = request.url;
    } else {
      // Client-side: always use current page URL
      urlString = window.location.href;
    }

    const url = new URL(urlString);
    const nocacheParam = url.searchParams.get('nocache');
    return nocacheParam === 'true';
  } catch (error) {
    // If URL parsing fails, default to no caching disabled
    return false;
  }
}
